import { render, staticRenderFns } from "./global-all-user-message.html?vue&type=template&id=53c02456&scoped=true&"
import script from "./global-all-user-message.js?vue&type=script&lang=js&"
export * from "./global-all-user-message.js?vue&type=script&lang=js&"
import style0 from "./global-all-user-message.scss?vue&type=style&index=0&id=53c02456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c02456",
  null
  
)

export default component.exports